import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const csmExperienceCreateArticleRoute: InvariantJiraRoute = {
	name: 'csm-experience-create-article',
	path: '/jira/customer-service-management/experiences/:projectKey/settings/:helpCenterId/articles/:articleId/space/:spaceKey/edit',
	query: ['draftShareId?', 'topicId?'],
};
